import { createFileRoute } from '@tanstack/react-router';
import {
  OAuthCallbackFailed,
  completeOAuthCallback,
  oauthCallbackSearch,
  requireOAuthCallbackAccess,
} from '@/components/integrations-hub/oauth-callback';

// HubSpot redirects here with ?code&state (the redirect URL registered with HubSpot).
export const Route = createFileRoute(
  '/_auth/_side-layout/integrations/hubspot/callback',
)({
  validateSearch: oauthCallbackSearch,
  beforeLoad: ({ context }) => requireOAuthCallbackAccess(context),
  loaderDeps: ({ search }) => search,
  loader: ({ deps, context }) =>
    completeOAuthCallback('hubspot', deps, context.queryClient),
  component: HubSpotCallbackPage,
});

function HubSpotCallbackPage() {
  const { failedReason } = Route.useLoaderData();
  return (
    <OAuthCallbackFailed integrationId="hubspot" failedReason={failedReason} />
  );
}
